var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.049,
    height: 21.049,
    viewBox: "0 0 21.049 21.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fdfdfd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.289 2.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.332.5H0",
    transform: "translate(4.162 11.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.332.5H0",
    transform: "translate(4.162 7.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.416.5H0",
    transform: "translate(4.162 3.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.663,0,3.919,0A3.728,3.728,0,0,0,0,4.04v8.065a3.731,3.731,0,0,0,3.952,4.04l6.744,0a3.729,3.729,0,0,0,3.92-4.038V4.04A3.732,3.732,0,0,0,10.663,0Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.63719eb73ecd584b5dbb2308db095fa7.svg";
export { ForwardRef as ReactComponent };